// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import { FooterComponent } from '@openbank/ziniaweb-ui-components';
import { LayoutFooterModalComponent } from './components/modal/layout-footer-modal.component';
// Configurations
import { getLayoutFooterMainButtonConfiguration } from './configurations/layout-footer.configuration';
// Constants
import {
  LAYOUT_COMPONENT_FOOTER_ACTION_LINK_PROPS,
  LAYOUT_COMPONENT_FOOTER_ACTION_PROPS,
} from './constants/layout-footer.constants';
// Hooks
import { useLayoutFooterHook } from './hooks/layout-footer.hook';
// Styles
import { LayoutBottomSideFooterComponentStyled } from './layout-footer.component.styled';
// Types
import { LayoutType } from 'components/layout/types/layout.type';
// Translations
import { CANCEL_APPLICATION_LINK } from './translations/layout-footer.translations';
// Utilities
import { getLayoutFooterVariant } from './utils/layout-footer.utils';

const LayoutFooterComponent = ({
  externalFetching,
}: Pick<LayoutType, 'externalFetching'>): React.JSX.Element | React.ReactNode => {
  const {
    buttonConfiguration,
    fetching,
    handleCloseCancelApplicationModalClick,
    handleCancelApplicationLinkClick,
    linkConfiguration,
    paddingContent,
    showModal,
  } = useLayoutFooterHook();

  return externalFetching ? null : (
    <LayoutBottomSideFooterComponentStyled {...{ paddingContent }}>
      <FooterComponent
        {...LAYOUT_COMPONENT_FOOTER_ACTION_PROPS}
        {...getLayoutFooterMainButtonConfiguration({ buttonConfiguration, fetching })}
        buttonGhostConfiguration={{
          ...LAYOUT_COMPONENT_FOOTER_ACTION_LINK_PROPS,
          children: <FormattedMessage id={CANCEL_APPLICATION_LINK} />,
          loading: fetching,
          onClick: handleCancelApplicationLinkClick,
          ...linkConfiguration,
        }}
        variant={getLayoutFooterVariant(buttonConfiguration)}
      />
      <LayoutFooterModalComponent
        {...{ showModal }}
        onClose={handleCloseCancelApplicationModalClick}
      />
    </LayoutBottomSideFooterComponentStyled>
  );
};

export { LayoutFooterComponent };
